import { graphql } from 'app/generated/gql'

// The SMS agent is available at a location when it has an AIAgentConfiguration
// with a non-empty systemPrompt. aiAgentConfigurations is an ops-schema query, so
// callers must run it against OPS_URL. It returns an array (no pagination wrapper).
// Typed with the generated graphql() tag. This operation targets the ops schema
// and keeps the explicit result shape used by the caller.
export const HAS_ACTIVE_AGENT_QUERY = graphql(`
  query HasActiveAgent($locationId: ID!) {
    aiAgentConfigurations(locationId: $locationId) {
      id
      systemPrompt
    }
  }
`)

export type HasActiveAgentResult = {
  aiAgentConfigurations: Array<{ id: string; systemPrompt?: string | null }>
}

export const THREAD_QUERY = graphql(`
  query Thread($id: ID!) {
    thread(id: $id) {
      id
      aiEnabled
      name
    }
  }
`)

export const INBOX_THREADS_QUERY = graphql(`
  query InboxThreads($search: String, $pagination: PaginationInput) {
    threads(search: $search, pagination: $pagination) {
      hits {
        id
        aiEnabled
        name
      }
    }
  }
`)

export const ENGAGE_AGENT_MUTATION = graphql(`
  mutation ThreadEngageAgent($threadId: ID!) {
    threadEngageAgent(threadId: $threadId) {
      id
      aiEnabled
      name
    }
  }
`)

export const UPDATE_THREAD_MUTATION = graphql(`
  mutation UpdateThread($id: ID!, $input: UpdateThreadInput!) {
    updateThread(id: $id, input: $input) {
      id
      aiEnabled
      name
    }
  }
`)
